import React from 'react';

export interface IChangelogContext {
  changelog: string;
}

const initialState: IChangelogContext = {
  changelog: '',
};

export const ChangelogContext =
  React.createContext<IChangelogContext>(initialState);
